<template lang="pug">
  div.alert.alert-danger(role='alert' v-if="message") {{ message }}
</template>

<script>
export default {
  props: ['message'],
};
</script>
